import { monthlySWPForLumpsum } from "../../engine/calculations";

const config = {
  key: "swp-monthly-for-lumpsum",
  title: "Monthly SWP For Lumpsum",
  category: "Retirement & Income",
  description: "See the level monthly income a lumpsum corpus can pay out until it's fully exhausted.",
  fields: [
    { key: "corpus", label: "Corpus", type: "currency", default: 50_00_000, min: 1000, max: 50_00_00_000 },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 7, min: 1, max: 20, assumptionKey: "debtReturn" },
    { key: "years", label: "Years the income should last", type: "number", default: 20, min: 1, max: 50 },
  ],
  compute(values) {
    const corpus = Number(values.corpus) || 0;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const years = Number(values.years) || 0;

    const monthlyWithdrawal = monthlySWPForLumpsum(corpus, annualRate, years);

    return {
      headline: { label: "Sustainable monthly withdrawal", value: monthlyWithdrawal },
      breakdown: [
        { label: "Corpus", value: corpus },
        { label: "Total withdrawn over the period", value: monthlyWithdrawal * years * 12 },
      ],
    };
  },
};

export default config;
